export const CHANNEL_GROUPS = Object.freeze({
    DESKTOP: ["SG-MO-APP", "MY-MO-APP"],
    MOBILE_WEB: ["SG-EB-APP", "MY-EB-APP"],
})

export const ALL_CHANNELS = Object.freeze([
    ...CHANNEL_GROUPS.DESKTOP,
    ...CHANNEL_GROUPS.MOBILE_WEB,
])

export function isDesktopChannel(id) {
    return CHANNEL_GROUPS.DESKTOP.includes(id)
}

export function isMobileWebChannel(id) {
    return CHANNEL_GROUPS.MOBILE_WEB.includes(id)
}
